const baseURL = 'http://192.168.0.24:3000';
// const baseURL = "http://3.128.45.144:3000";

export default baseURL;
